// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_avatar__v526X","avatar__isSquare":"avatar_avatar__isSquare__2Ql3G"};